import { env } from '@env';

/**
 * The website verify page URL — opened in a popup by the landing.
 * If the user already has a session, it relays it back immediately.
 * Otherwise it redirects to /sign-in where the user can choose any
 * auth method (Google, Apple, magic link).
 * @type {string}
 */
export const WEBSITE_SIGN_IN_PATH: string =
  env.NEXT_PUBLIC_WEBSITE_APP_URL + '/sign-in/verify';

/**
 * The path for Google OAuth in the API
 * @type {string}
 */
export const GOOGLE_OAUTH_API_PATH: string =
  env.NEXT_PUBLIC_API_URL +
  `/auth/google?redirect_to=${env.NEXT_PUBLIC_APP_URL.includes('staging') ? 'staging' : 'frontend'}`;

/**
 * The path for Twitter OAuth in the API
 * @type {string}
 */
export const TWITTER_OAUTH_API_PATH: string =
  env.NEXT_PUBLIC_API_URL + '/auth/twitter';
